export default __webpack_public_path__ + "static/media/nosql.54933bdc.png";